module.exports = __webpack_public_path__ + "static/media/bg_bookshelf.5c4cf921.png";